import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '../../auth/authCompat';
import NavLinks from '../NavBar/NavLinks';
import SocialLinks from '../SocialLinks';
import { getLoginReturnTo } from '../../utilities/authUtils';
import './Footer.css';

const Footer = () => {
  const { pathname, hash } = useLocation();
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const getIsActivePath = (linkToMatch, isExact = false) =>
    linkToMatch === pathname && ((isExact && !hash) || !isExact)
      ? 'footer__navbar__link--active'
      : '';
  return (
    <footer className="footer">
      <div>
        <NavLinks getIsActivePath={getIsActivePath} />
      </div>
      {!isAuthenticated && (
        <div>
          <button
            type="button"
            className="btn btn-link"
            onClick={() =>
              loginWithRedirect({
                appState: { returnTo: getLoginReturnTo() },
              })
            }
          >
            Log in
          </button>
        </div>
      )}
      <div className="mb-5">
        <SocialLinks />
      </div>
      <div className="footer__legal">
        <Link to="/privacy" className="footer__legal__link">
          Privacy Policy
        </Link>
        <Link to="/terms" className="footer__legal__link">
          Terms of Service
        </Link>
      </div>
      <p>&copy; Lou Bro Studio Mtl.</p>
    </footer>
  );
};

export default Footer;
